// extracted by mini-css-extract-plugin
export default {"myAccount":"myAccount_myAccount__f6V4D","loaderCenterer":"myAccount_loaderCenterer__L3xa6","loader":"myAccount_loader__vIhV9"};